export const Slice = ({ x, y, innerRadius, outerRadius, startAngle, sweepAngle, fill, fillOpacity, stroke, strokeWidth, opacity, transition = 0.5, onClick }) => {
  const startAngleRadians = (startAngle - 90) * (Math.PI / 180)
  const sweepAngleRadians = sweepAngle * (Math.PI / 180)

  // calculate coordinates for the end points of the inner and outer arcs
  const innerStartX = x + innerRadius * Math.cos(startAngleRadians)
  const innerStartY = y + innerRadius * Math.sin(startAngleRadians)
  const innerSweepX = x + innerRadius * Math.cos(startAngleRadians + sweepAngleRadians)
  const innerSweepY = y + innerRadius * Math.sin(startAngleRadians + sweepAngleRadians)
  const outerStartX = x + outerRadius * Math.cos(startAngleRadians)
  const outerStartY = y + outerRadius * Math.sin(startAngleRadians)
  const outerSweepX = x + outerRadius * Math.cos(startAngleRadians + sweepAngleRadians)
  const outerSweepY = y + outerRadius * Math.sin(startAngleRadians + sweepAngleRadians)

  //         Move to the outer start point  Arc of outerRadius across to the outer sweep point                 Line to inner sweep point      Arc of innerRadius across to inner start point                     close the shape
  const d = `M${outerStartX},${outerStartY} A${outerRadius},${outerRadius} 0 0,1 ${outerSweepX},${outerSweepY} L${innerSweepX},${innerSweepY} A${innerRadius},${innerRadius} 0 0,0 ${innerStartX},${innerStartY} Z`

  return <path
    d={d}
    fill={fill}
    fillOpacity={fillOpacity}
    stroke={stroke}
    strokeWidth={strokeWidth}
    style={{ transition: `${transition}s linear`, pointerEvents: 'auto', opacity, cursor: 'pointer' }}
    onClick={onClick}
  />
}
